import { endpoints } from "../config";
import { getData, postData, putData, deleteData } from "./api-utils";

const routeURL = endpoints.question;

const getQuestion = async () => {
  return await getData(routeURL);
};
const postQuestion = async (data) => {
  return await postData(routeURL, data);
};
const updateQuestion = async (data, itemId) => {
  return await putData(`${routeURL}/${itemId}`, data);
};
const deleteQuestion = async (itemId) => {
  return await deleteData(`${routeURL}/${itemId}`);
};

export { getQuestion, postQuestion, updateQuestion, deleteQuestion };
